import React, { useEffect, useState } from 'react'

const CACHE_KEY = 'geoip_cache_v1'
const CACHE_TTL_MS = 4 * 60 * 60 * 1000 // 4 hours

const CITY_TO_REGION = {
  'New York': 'New York City',
  Brooklyn: 'New York City',
  Miami: 'Miami',
  Washington: 'Washington DC',

  'San Francisco': 'Northern California',
  Oakland: 'Northern California',
  'Los Angeles': 'Los Angeles',
  'Santa Monica': 'Los Angeles',

  Chicago: 'Chicago',
  Austin: 'Austin',
  Seattle: 'Seattle',
  Portland: 'Portland',
  Vancouver: 'Vancouver',
  Boston: 'Boston',
}

/** Return the matching region name or `null` */
const cityToRegion = (city = '') => {
  return CITY_TO_REGION[city.trim()] || null
}

export default function RegionAutoSuggest({ currentRegion, allRegions, changeRegion }) {
  const [suggested, setSuggested] = useState(null) // { slug, city }

  // Check location by IP every 4 hours
  useEffect(() => {
    if (!currentRegion) return
    const now = Date.now()

    // Try localStorage cache first
    const cached = (() => {
      try {
        const raw = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null')
        return raw && now - raw.ts < CACHE_TTL_MS ? raw : null
      } catch {
        return null
      }
    })()

    const handleCity = ({ city }) => {
      if (!city) return
      const slug = cityToRegion(city)
      if (slug && slug !== currentRegion.name && allRegions.find((r) => r.name === slug)) {
        setSuggested({ slug, city })
      }
    }

    if (cached) {
      handleCity(cached)
      return
    }

    // No fresh cache → fetch
    ;(async () => {
      try {
        const res = await fetch('https://ipapi.co/json') // swap provider if needed
        const data = await res.json()
        const { city } = data || {}
        localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: now, city }))
        handleCity({ city })
      } catch {
        /* swallow network errors; we simply don't suggest */
      }
    })()
  }, [currentRegion, allRegions])

  return (
    <>
      {suggested && (
        <a
          className="text-muted p-2"
          href="#"
          onClick={() => {
            changeRegion(suggested.slug)
            setSuggested(null)
          }}
        >
          <small>
            Switch to <strong>{suggested.slug}</strong>?
          </small>
        </a>
      )}
    </>
  )
}
